<div
  [class]="parentContainerClasses()"
  tabindex="-1"
  (click)="toggleSelection()"
  (keyup.space)="toggleSelection()"
  (keyup.enter)="toggleSelection()"
  role="radio"
  [attr.aria-checked]="selected()"
  [attr.aria-disabled]="isDisabled()"
>
  <div [class]="radioContainerClasses()" [tabindex]="isDisabled() ? -1 : 0">
    @if (selected()) {
      <div [class]="innerCircleClasses()"></div>
    }
  </div>
  <span [class]="labelClasses()">{{ label() }}</span>
</div>
